/*
 * @Description: 
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 17:46:54
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2026-02-02 13:46:21
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http_pad';
import { type } from './interface';
import qs from 'qs';
export namespace TbReturnOrder {
    /**
     * 新增退货单(有单退货)
     */
    export var PostReturnOrderV2 = (body: any): Promise<any> => {
        return Post(`/api/TbReturnOrder/PostReturnOrderV2`, body);
    };
    /**
     * 退货单详情
     */
    export var GetReturnOrderInfoById = (body: any): Promise<any> => {
        return Get(`/api/TbReturnOrder/GetReturnOrderInfoById`, body);
    };
    /**
     * 获取退货信息
     */
    export var GetReturnOrderInfo = (body: any): Promise<any> => {
        return Post(`/api/TbReturnOrder/GetReturnOrderInfo`, body);
    };
     /**
     * 获取异常退货单列表
     */
    export var GetAbnormalTbReturnOrderList = (body: any): Promise<any> => {
        return Get(`/api/TbReturnOrder/GetAbnormalTbReturnOrderList`, body);
    };
    /**
     * 获取异常退货单统计
     */
    export var GetAbnormalTbReturnOrderTotal = (body: any): Promise<any> => {
        return Get(`/api/TbReturnOrder/GetAbnormalTbReturnOrderTotal`, body);
    };
    /**
     * 异常下的退货单详情
     */
    export var GetAbnormalReturnOrderInfoById = (body: any): Promise<any> => {
        return Get(`/api/TbReturnOrder/GetAbnormalReturnOrderInfoById`, body);
    };
    /**
     * 再次发起线上退款
     */
    export var AgainOnlineReturnOrder = (body: any): Promise<any> => {
        return Post(`/api/TbReturnOrder/AgainOnlineReturnOrder`, body);
    };
    /**
     * 获取销售订单退货次数
     */
    export var GetReturnOrderNum = (body: any): Promise<any> => {
        return Get(`/api/TbReturnOrder/GetReturnOrderNum`, body);
    };
    /**
     * 查询退款订单状态并修改
     */
    export var GetReturnOrderStatus = (body: any): Promise<any> => {
        return Get(`/api/TbReturnOrder/GetReturnOrderStatus`, body);
    };
    /**
     * 查询退款订单状态并修改
     */
    export var CloseOnlineReturnOrder = (body: any): Promise<any> => {
        return Get(`/api/TbReturnOrder/CloseOnlineReturnOrder`, body);
    };
}



// WEBPACK FOOTER //
// ./src/http/api_TbReturnOrder.ts